export default __webpack_public_path__ + "52b68d72a6505c26a5712a191f44ac0f.svg";